import { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { ContratoDropDown } from '../domain/models/contrato_dropdown';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
};

export const DefaultContrato = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [contratoDropDown, setContratoDropDown] = useState<ContratoDropDown[]>([]);

  const {
    commons: {
      getContratoDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadContratoDropDown = useCallback(async () => {
    try {
      const result = await getContratoDropDownUseCase.getContratoDropDown();
      setContratoDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar contratos!'));
    }
  }, [getContratoDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadContratoDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={contratoDropDown}
        getOptionLabel={(opt) => String(opt.codigoDescricao)}
        isOptionEqualToValue={(opt, val) => String(opt.codigoDescricao) === String(val.codigoDescricao)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={contratoDropDown.find(x => String(x.codigo) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.codigo : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};